export default () => ({
  step: 0,
  init() {},
});
